// ABOUTME: Search widget allowing users to query multiple search engines.
// ABOUTME: Supports DuckDuckGo, Google, ChatGPT, Bing, Gmail, and Google Drive.
import React, { useState } from "react";
// Shared with the header search launcher so a query matching no link can offer the
// user's own preferred engine.
import { SEARCH_ENGINES, engineIndex } from "../utils/searchEngines";
import { useUIStore } from "../stores/ui";

interface SearchWidgetProps {
  className?: string;
}

function SearchWidget({ className = "" }: SearchWidgetProps) {
  const [searchTerm, setSearchTerm] = useState("");
  // The engine choice is a synced preference (see usePrefsSync), so it follows
  // the account instead of the browser.
  const engineIdx = useUIStore((s) => engineIndex(s.searchEngineIdx));
  const setEngineIdx = useUIStore((s) => s.setSearchEngineIdx);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;
    const searchUrl = SEARCH_ENGINES[engineIdx].url(searchTerm);
    window.open(searchUrl, "_blank", "noopener,noreferrer");
    setSearchTerm("");
  };

  return (
    <div
      className={`rounded-[var(--radius-md)] bg-[var(--color-bg-secondary)] border border-[var(--color-border)] p-4 flex flex-col gap-2 transition-colors ${className}`}
    >
      <div className="mb-1">
        <select
          className="px-2 py-0.5 rounded-[var(--radius-md)] bg-[var(--color-bg)] border border-[var(--color-border)] text-xs text-[var(--color-accent)] focus:outline-none focus:ring-1 focus:ring-[var(--color-accent)]"
          value={engineIdx}
          onChange={(e) => setEngineIdx(Number(e.target.value))}
        >
          {SEARCH_ENGINES.map((engine, idx) => (
            <option key={engine.name} value={idx}>
              {engine.name}
            </option>
          ))}
        </select>
      </div>
      <form onSubmit={handleSubmit} className="flex items-center gap-2">
        <div className="relative flex-1 flex">
          <input
            type="text"
            name="q"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder={`Search ${SEARCH_ENGINES[engineIdx].name}`}
            className="w-full pl-4 pr-14 py-2 rounded-[var(--radius-md)] bg-[var(--color-bg)] text-[var(--color-text-primary)] border border-[var(--color-border)] focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:border-[var(--color-accent)] transition-colors"
          />
          <button
            type="submit"
            className="absolute right-2 top-1/2 -translate-y-1/2 h-9 w-9 flex items-center justify-center rounded-full bg-[var(--color-accent)] text-[var(--color-text-inverse)] hover:opacity-90 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)]"
            aria-label="Search"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.3-4.3" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
}

export default SearchWidget;
